const limitDescription = (description) => {
  if (!description) return null
  else if (description.length > 250) {
    return `${description.substring(0,250)}…`
  } else {
    return description;
  }
}

export default limitDescription;